export default "__VITE_ASSET__abcce936__"